import './StarBorderGlow.css';

// Inšpirované React Bits <StarBorder /> — svetelný „star" sweep okolo okraja
// tlačidla + jemné modré halo. Aktivuje sa cez `active` (priblíženie kurzora)
// alebo cez :hover (fallback). Nemení samotné tlačidlo, len ho obalí.
const StarBorderGlow = ({
  active = false,
  color = '#ffffff',
  speed = '2.6s',
  thickness = 2,
  className = '',
  children
}) => {
  const barStyle = {
    background: `radial-gradient(circle, ${color}, transparent 12%)`,
    animationDuration: speed
  };
  return (
    <span
      className={`star-border-glow${active ? ' is-active' : ''}${className ? ` ${className}` : ''}`}
      style={{ padding: `${thickness}px` }}
    >
      <span className="star-border-glow__bar star-border-glow__bar--bottom" style={barStyle} aria-hidden="true" />
      <span className="star-border-glow__bar star-border-glow__bar--top" style={barStyle} aria-hidden="true" />
      <span className="star-border-glow__inner">{children}</span>
    </span>
  );
};

export default StarBorderGlow;
